import React from 'react';
import { FileText, Clock, Warning, CheckCircle } from '@phosphor-icons/react';

export const CaseStats = ({ documents, timeline, contradictions, analyzedDocs }) => {
  const stats = [
    { label: 'Documents', value: documents.length, icon: FileText, color: '#002FA7' },
    { label: 'Timeline Events', value: timeline.length, icon: Clock, color: '#34C759' },
    { label: 'Contradictions', value: contradictions.length, icon: Warning, color: '#FF3B30' },
    { label: 'Analyzed', value: analyzedDocs.length, icon: CheckCircle, color: '#002FA7' },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {stats.map(s => (
        <div key={s.label} className="bg-white border border-[#E5E7EB] rounded-lg p-4" data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, '-')}`}>
          <div className="flex items-center gap-2 mb-1">
            <s.icon size={16} style={{ color: s.color }} />
            <span className="text-xs font-bold tracking-[0.15em] uppercase text-[#6B7280] font-ibm">{s.label}</span>
          </div>
          <p className="font-outfit text-2xl font-bold text-[#09090B]">{s.value}</p>
        </div>
      ))}
    </div>
  );
};
